/**
 * Validate every step's fields at once and return the index of the first step
 * that fails, or null when the form is clean. Used before jumping to the recap.
 */
export async function findFirstInvalidStep({
  fieldsByStep,
  trigger,
  hasError,
}) {
  const fields = fieldsByStep.flat();
  if (fields.length === 0) return null;
  if (await trigger(fields)) return null;

  const index = fieldsByStep.findIndex((stepFields) =>
    stepFields.some((field) => hasError(field))
  );
  return index === -1 ? null : index;
}
